import { Button } from "@/components/ui/button";
import { Rocket, XCircle, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

interface WaitlistScreenProps {
  status?: "pending" | "rejected" | string;
}

export default function WaitlistScreen({ status = "pending" }: WaitlistScreenProps) {
  const { signOut } = useAuth();
  const isRejected = status === "rejected";

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm text-center space-y-6">
        <div className={`mx-auto flex h-20 w-20 items-center justify-center rounded-full ${isRejected ? "bg-destructive/10" : "bg-primary/10"}`}>
          {isRejected ? (
            <XCircle className="h-10 w-10 text-destructive" />
          ) : (
            <Rocket className="h-10 w-10 text-primary" />
          )}
        </div>

        <div className="space-y-2">
          {isRejected ? (
            <>
              <h1 className="text-2xl font-bold text-foreground">Access Not Approved</h1>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Unfortunately, your access request was not approved at this time. If you believe this is an error, please contact support and we'll be happy to help.
              </p>
            </>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-foreground">You're on the List!</h1>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Thanks for signing up! Due to high demand, we're granting access in batches to ensure the best experience for everyone. Your spot is secured — we'll notify you by email as soon as it's your turn. Hang tight!
              </p>
            </>
          )}
        </div>

        <Button variant="outline" onClick={() => signOut()} className="gap-2">
          <LogOut className="h-4 w-4" />
          Sign Out
        </Button>
      </div>
    </div>
  );
}
